export const IconView = ({ size = 24 }) => (
	<svg
		width={size}
		height={size}
		viewBox={`0 0 ${size} ${size}`}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform={`scale(${size / 24})`}>
		<path
			d="M17.1283 14.4877C17.1283 14.1667 16.7479 14.0149 16.4613 14.1595C16.0452 14.3694 15.5749 14.4877 15.077 14.4877C13.3776 14.4877 12 13.1101 12 11.4107C12 10.9128 12.1183 10.4425 12.3283 10.0264C12.4729 9.73984 12.321 9.35939 12 9.35939C9.16773 9.35939 6.8717 11.6554 6.8717 14.4877C6.8717 17.32 9.16773 19.616 12 19.616C14.8323 19.616 17.1283 17.32 17.1283 14.4877Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.0541 12.3925C3.87863 6.99179 9.37087 3.86734 14.7368 5.38179C18.2226 6.3656 20.824 9.07577 21.9458 12.3921C22.1172 12.899 21.8706 13.4701 21.3674 13.659C20.857 13.8505 20.3108 13.5649 20.1375 13.0528C19.2126 10.3186 17.077 8.10606 14.2342 7.30372C9.86672 6.07109 5.36427 8.60747 3.86264 13.0524C3.68959 13.5646 3.14346 13.8505 2.63305 13.6592C2.12967 13.4705 1.88285 12.8994 2.0541 12.3925Z"
			fill="currentColor"
		/>
		</g>
	</svg>
);
